__webpack_require__.p = "/lovelace-logs/";